import { render, staticRenderFns } from "./base-auth.vue?vue&type=template&id=9ea8e3b8&scoped=true&"
import script from "./base-auth.vue?vue&type=script&lang=js&"
export * from "./base-auth.vue?vue&type=script&lang=js&"
import style0 from "./base-auth.vue?vue&type=style&index=0&id=9ea8e3b8&scoped=true&lang=css&"
import style1 from "./base-auth.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea8e3b8",
  null
  
)

export default component.exports